@if (wrapBody) {
  @if (stateName !== 'EMPTY_STATE') {
    <div [style.minHeight]="minHeight" [style.box-shadow]="'none'">
      <ng-container *ngTemplateOutlet="body"></ng-container>
    </div>
  }
} @else {
  @if (suggestionsToDisplay.length > 0) {
    <div rtScrollable (reachEnd)="onReachEnd()" [style.maxHeight]="maxHeight">
      <ng-container
        *ngTemplateOutlet="
          suggestionListTemplate || defaultSuggestionList;
          context: {
            suggestions: suggestionsToDisplay,
            highlighted: highlighted
          }
        "
      ></ng-container>
    </div>
  }
  @if (stateName === 'LOADING_STATE') {
    <ng-container [ngTemplateOutlet]="spinnerTemplate || spinner"></ng-container>
  }
}

<ng-template #body>
  @if (suggestionsToDisplay.length > 0) {
    <div rtScrollable (reachEnd)="onReachEnd()" [style.maxHeight]="maxHeight">
      <ng-container
        *ngTemplateOutlet="
          suggestionListTemplate || defaultSuggestionList;
          context: {
            suggestions: suggestionsToDisplay,
            highlighted: highlighted
          }
        "
      ></ng-container>
    </div>
  }
  @if (stateName === 'LOADING_STATE') {
    <ng-container [ngTemplateOutlet]="spinnerTemplate || spinner"></ng-container>
  }
</ng-template>

<ng-template #spinner>
  <rt-spinner variant="small"></rt-spinner>
</ng-template>

<ng-template #defaultSuggestionList let-suggestions="suggestions">
  @for (suggestion of suggestions; track trackSuggestion($index, suggestion)) {
    <ng-container
      *ngTemplateOutlet="
        suggestionItemTemplate || defaultSuggestionItem;
        context: {
          suggestion: suggestion,
          highlighted: highlighted,
          label: highlightValue(suggestion.value, stateValue),
          select: suggestionSelect.emit.bind(suggestionSelect)
        }
      "
    ></ng-container>
  }
</ng-template>

<ng-template
  #defaultSuggestionItem
  let-highlighted="highlighted"
  let-suggestion="suggestion"
  let-label="label"
  let-select="select"
>
  <rt-dropdown-item [highlighted]="suggestion.id === highlighted" (click)="select(suggestion)">
    <div [innerHTML]="label"></div>
  </rt-dropdown-item>
</ng-template>
